export type BrandingLayout = "sidebar" | "standalone" | "auth";

export type LogoSize = "mini" | "large";

/** App theme: light UI uses dark-colored logo assets and vice versa. */
export type AppThemeMode = "light" | "dark";

const LOGO_BASE = "./assets/images/logos/logos-demo";

export const TREESLO_LOGO_PATHS: Record<
  LogoSize,
  Record<AppThemeMode, string>
> = {
  mini: {
    light: `${LOGO_BASE}/logo-mini-dark.png`,
    dark: `${LOGO_BASE}/logo-mini-ligth.png`,
  },
  large: {
    light: `${LOGO_BASE}/logo-large-dark.png`,
    dark: `${LOGO_BASE}/logo-large-ligth.png`,
  },
};

export function getTreesloLogoPath(
  size: LogoSize,
  theme: AppThemeMode,
): string {
  return TREESLO_LOGO_PATHS[size][theme];
}

export function resolveAppThemeMode(theme: string | undefined): AppThemeMode {
  return theme === "dark" ? "dark" : "light";
}

/** Blank-layout auth screens always use light UI — pick dark-colored logo assets. */
export function resolveLogoThemeMode(
  layout: BrandingLayout,
  theme: string | undefined,
): AppThemeMode {
  if (layout === "auth") {
    return "light";
  }

  if (layout === "sidebar") {
    return "dark";
  }

  return resolveAppThemeMode(theme);
}
